// @flow
import React from 'react';

import PopupContainer from '../PopupContainer';
import CreateGatePopupForm from './CreateGatePopupForm';


const CreateGatePopup = () => (
  <PopupContainer size="small">
    <CreateGatePopupForm />
  </PopupContainer>
);


export default CreateGatePopup;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateGatePopupContent/index.jsx